"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.findCanvasSurfaceElements = void 0;
exports.restorableTrashConnectors = restorableTrashConnectors;
exports.collectAttachedCanvasConnectorIds = collectAttachedCanvasConnectorIds;
exports.leaveCanvasGroup = leaveCanvasGroup;
exports.takeTrashCanvasMembers = takeTrashCanvasMembers;
exports.restoreTrashCanvasMembers = restoreTrashCanvasMembers;
const Y = __importStar(require("yjs"));
const page_canvas_1 = require("./page-canvas");
const page_document_maps_1 = require("./page-document-maps");
function connectorEndId(end) {
    if (!end || typeof end !== 'object' || !('id' in end))
        return undefined;
    return typeof end.id === 'string' ? end.id : undefined;
}
/**
 * The trashed connectors that come back with their entry, the editor's and the
 * server's trash alike: an end on the entry points to the restored block, and
 * a connector whose other end no longer exists stays out.
 */
function restorableTrashConnectors(connectors, { entryId, restoredId, exists, }) {
    return connectors.flatMap(connector => {
        const next = { ...connector };
        for (const key of ['source', 'target']) {
            const end = next[key];
            if (connectorEndId(end) === entryId) {
                next[key] = { ...end, id: restoredId };
            }
        }
        const ends = [connectorEndId(next.source), connectorEndId(next.target)];
        return ends.every(id => id === undefined || id === restoredId || exists(id))
            ? [next]
            : [];
    });
}
exports.findCanvasSurfaceElements = page_canvas_1.pageDocumentCanvas;
/**
 * Adds to `ids` the connectors with an end on one of them. The editor deletes
 * them along with it; left standing they would point at nothing.
 */
function collectAttachedCanvasConnectorIds(elements, ids) {
    const endIn = (end) => {
        const id = connectorEndId(end);
        return id !== undefined && ids.has(id);
    };
    // The kind stands in the head, so a connector in a part still loading counts.
    for (const elementId of elements.ids()) {
        if (elements.writer.entries().get(elementId)?.k !== 'connector')
            continue;
        const element = elements.get(elementId);
        if (!element)
            continue;
        if (endIn(element.get('source')) || endIn(element.get('target'))) {
            ids.add(elementId);
        }
    }
}
/**
 * Takes a member out of its canvas group, as the editor does; a group left
 * without members goes as well. Only real groups: frames and mind maps keep
 * their own membership, like the editor's trash.
 */
function leaveCanvasGroup(elements, memberId) {
    const entries = elements.writer.entries();
    const groupId = entries.get(memberId)?.g;
    if (!groupId || entries.get(groupId)?.k !== 'group')
        return undefined;
    elements.writer.setGroup(memberId, undefined);
    if (elements.members(groupId).length === 0) {
        leaveCanvasGroup(elements, groupId);
        elements.remove(groupId);
    }
    return groupId;
}
/**
 * Takes the canvas members of a trashed block out of the surface, as the
 * editor's trash does: its connectors (plain JSON of each element, removed)
 * and the groups the block and those connectors belonged to (left).
 */
function takeTrashCanvasMembers(elements, { entryId, ids }) {
    const groups = {};
    if (!elements)
        return { connectors: [], groups };
    const attached = new Set(ids);
    collectAttachedCanvasConnectorIds(elements, attached);
    const connectorIds = [...attached].filter(id => !ids.has(id));
    const connectors = connectorIds.map(id => ({
        ...elements.get(id).toJSON(),
        index: elements.order(id),
    }));
    for (const memberId of [entryId, ...connectorIds]) {
        const groupId = leaveCanvasGroup(elements, memberId);
        if (groupId)
            groups[memberId] = groupId;
    }
    for (const id of connectorIds)
        elements.remove(id);
    return { connectors, groups };
}
/** A connector element as the editor writes it; its label is a Y.Text. */
function connectorElement(connector) {
    const element = new Y.Map();
    for (const [key, value] of Object.entries(connector)) {
        element.set(key, key === 'text' && typeof value === 'string' ? new Y.Text(value) : value);
    }
    return element;
}
/**
 * Brings back the canvas members of an entry restored under its own id: the
 * connectors whose ends exist, each into the group it left when that group
 * still stands, and the block into its group the same way.
 */
function restoreTrashCanvasMembers(exists, elements, { entryId, connectors, groups, }) {
    if (!elements)
        return;
    const members = [entryId];
    for (const connector of restorableTrashConnectors(connectors, {
        entryId,
        restoredId: entryId,
        exists,
    })) {
        const id = String(connector.id);
        if (elements.has(id))
            continue;
        // A connector the trash marked deleted comes back in the part that keeps
        // its fields; one without an entry goes into the page part.
        elements.set(id, connectorElement(connector), String(connector.index), elements.writer.entries().get(id)?.s ?? page_document_maps_1.PAGE_DOCUMENT_PART_ID);
        members.push(id);
    }
    for (const memberId of members) {
        const groupId = groups[memberId];
        if (groupId && elements.get(groupId)?.get('type') === 'group')
            elements.writer.setGroup(memberId, groupId);
    }
}
